// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"48c3bf49","453":"d1b8fc7b","993":"2e5cfa8c"}[chunkId] + ".chunk.js";
};